module.exports = __webpack_public_path__ + "img/newdataset_segmentation.3a790f37.png";